import React, { type ReactNode } from 'react';

import { ConditionalRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

export function MenuWrapper({ children }: { children: ReactNode }) {
	return <ConditionalRelayEnvironmentProvider>{children}</ConditionalRelayEnvironmentProvider>;
}
